export const Status = {
    All: 'All',
    Current: 'Current',
    Waitlist: 'Waitlist',
    Hiatus: 'Hiatus',
    Expired: 'Expired',
} as const;

export const ORG_TYPE_TOOLTIP = `Show incentives applicable based on the type of organization selected.`;

export const ZIPCODE_TOOLTIP =
    'The zip or postal code of your project will be used to determine electricity pricing and potentially identify incentives.';
